export enum LoadingIndicatorStyles {
  OverNeutralBackground = 'simx-style--over-neutral-background',
  OverDarkAccentBackground = 'simx-style--over-dark-accent-background',
  OverBrightAccentBackground = 'simx-style--over-bright-accent-background',
}
